module.exports = __webpack_public_path__ + "static/media/video.3bf1a39f.webm";